export default "__VITE_ASSET__Dk6lfEcn__"